import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    '& .MuiSelect-selectMenu': {
      textOverflow: 'unset',
    },
    maxWidth: 980,
    // minWidth: 400,
    marginTop: 30,
    marginBottom: 45,
    width: '95%',
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginTop: 8,
      marginBottom: 8,
    },
    fontFamily: 'Noto Sans JP',
  },

  dialogContainer: {
    padding: '32px',
    position: 'relative',
    overflowY: 'auto',
  },
  btnCloseOutside: {
    position: 'absolute',
    top: '-30px',
    right: '-30px',
    width: '30px',
    height: '30px',
    fontSize: '40px',
    color: '#fff',
    cursor: 'pointer',
    background: 'transparent',
    outline: 'none',
    border: 'none',
    '&::before, &::after': {
      position: 'absolute',
      left: '15px',
      content: '""',
      height: '33px',
      width: '3px',
      backgroundColor: '#ffffff',
    },
    '&::before': {
      transform: 'rotate(45deg)',
    },
    '&::after': {
      transform: 'rotate(-45deg)',
    },
  },
  dialogTitle: {
    borderBottom: '3px solid #b9bebe',
    paddingBottom: '18.6px',
    color: '#000',
    fontSize: '30px',
    lineHeight: '45px',
    fontFamily: 'Noto Sans JP',
    marginTop: 0,
  },
  dialogContent: {
    marginTop: '20px',
    fontSize: '16px',
    color: '#6f7878',
    letterSpacing: '0.05em',
    lineHeight: 1.5,
    wordWrap: 'break-word',
    fontWeight: 500,
    fontFamily: 'Noto Sans JP',
  },
  dialogBtn: {
    paddingTop: '4.375em',
    paddingBottom: '0.62em',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& button': {
      color: '#999999',
      border: '1px solid #999999',
      fontSize: '16px',
      lineHeight: '24px',
      textAlign: 'center',
      fontWeight: 400,
      background: 'transparent',
      padding: '6px 25px',
      cursor: 'pointer',
    },

  },
}));

export default useStyles;
